import JemConfigurationSerializer from 'eflex/serializers/jem-configuration';

export default class StationJemConfigurationSerializer extends JemConfigurationSerializer {}
